import { Box, Section } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'
import { PerformanceProcessSettingsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import { isFeatureAvailabilityEnabled } from 'modules/core/lib/isFeatureAvailabilityEnabled'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { CompanyEstimateManagerScore } from 'modules/performance_process/components/CompanyEstimateManagerScore'
import { CompanyEmployeeScoreScaleSelector } from 'modules/performance_process/components/companyEmployeeScoreScaleSelector'
import SettingsCollectionsBootstrap from 'modules/performance_process/lib/SettingsCollectionsBootstrap'

const Component = () => {
  const { company } = useCurrentSession()
  const { data, loading, error } = useQuery(PerformanceProcessSettingsDocument, {
    variables: { companyId: company.id },
  })

  const canSeeSettings =
    !!data?.performance._policies.settingsSeePerformanceReviewProcessSettings.can
  const scaleId = data?.performance.companyEmployeeScoreScales[0]?.scaleId
  const scoreScales = data?.performance.employeeScoreScalesConnection.nodes || []
  const companySetting = data?.performance.companySetting

  const featureAvailabilities = data?.companies.featureAvailabilitiesConnection.nodes || []
  const hasCustomScoreConfigurationEnabled = isFeatureAvailabilityEnabled(
    featureAvailabilities,
    Features.review_process_custom_score_configuration
  )

  return (
    <ResponsivePage.Body
      authorized={canSeeSettings}
      loading={loading}
      error={error}
      showHeader={false}
    >
      <Box gap="s16">
        <Section.Form
          illustration="crown"
          title={i18n.t('performance_process.employee_score.company_settings.title')}
          description={i18n.t('performance_process.employee_score.company_settings.description')}
        >
          <CompanyEmployeeScoreScaleSelector
            companyId={company.id}
            currentScaleId={scaleId}
            scoreScales={scoreScales}
          />
        </Section.Form>

        <Section
          illustration="eNPS"
          title={i18n.t(
            'performance_process.employee_score.company_settings.dynamic_scoring.title'
          )}
          description={''}
        >
          {companySetting && (
            <CompanyEstimateManagerScore
              companySetting={companySetting}
              hasCustomScoreConfigurationEnabled={hasCustomScoreConfigurationEnabled}
            />
          )}
        </Section>
      </Box>
    </ResponsivePage.Body>
  )
}

const PerformanceProcessSettings = () => {
  return (
    <SettingsCollectionsBootstrap>
      <Component />
    </SettingsCollectionsBootstrap>
  )
}

export default PerformanceProcessSettings
